import { render, staticRenderFns } from "./NBC.vue?vue&type=template&id=4d1c07b6&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./NBC.vue?vue&type=script&lang=js&"
export * from "./NBC.vue?vue&type=script&lang=js&"
import style0 from "./NBC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports